import './styles/globals.css'
import './index.css'

import { ChakraProvider } from '@chakra-ui/react'
import Kalvium from '@kalvi-education/kalvium-sdk'
import { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import Router from './app/router.jsx'
import chakraTheme from './chakraTheme'
import IssueReporter from './common/IssueReporter/index.jsx'
import UnitFeedback from './common/UnitFeedback/index.jsx'
import ErrorFallback from './components/ErrorFallback'
import PageLoader from './components/PageLoader'
import { AuthContext } from './contexts/AuthContext'
import { SideDrawerProvider } from './pages/Launcher/MyDayView/context/SideDrawerProvider.jsx'
import { DojoProvider } from './providers/DojoProvider'
import { FullScreenProvider } from './providers/FullScreenProvider.jsx'
import { IssueReporterProvider } from './providers/IssueReporterProvider.jsx'
import { ProctoringProvider } from './providers/ProctoringProvider'
import { ThemeProvider } from './providers/ThemeProvider'

// Configure Keycloak
export const kalviumSDK = new Kalvium.KalviumSDK({
    url: import.meta.env.VITE_AUTH_ENDPOINT,
    realm: import.meta.env.VITE_AUTH_REALM,
    clientId: 'login_client',
})
// Configure SDK
kalviumSDK.setAuthoringAP(import.meta.env.VITE_API_ENDPOINT + '/')
kalviumSDK.setFeedbackAP(import.meta.env.VITE_FEEDBACK_API_ENDPOINT + '/')
kalviumSDK.setSecurityAP(import.meta.env.VITE_SECURITY_API_ENDPOINT + '/')
kalviumSDK.setAssessmentAP(import.meta.env.VITE_ASSESSMENT_API_ENDPOINT + '/')
kalviumSDK.setStudentAP(import.meta.env.VITE_STUDENT_API_ENDPOINT + '/')
kalviumSDK.setAdmissionAP(import.meta.env.VITE_ADMISSION_API_ENDPOINT + '/')
kalviumSDK.setDojoAP(import.meta.env.VITE_DOJO_API_ENDPOINT + '/')
kalviumSDK.setLivebookProgressAP(
    import.meta.env.VITE_LIVEBOOK_PROGRESS_API_ENDPOINT + '/'
)
kalviumSDK.setAttendanceAP(import.meta.env.VITE_ATTENDANCE_API_ENDPOINT)
kalviumSDK.setSignalAP(import.meta.env.VITE_SIGNAL_API_ENDPOINT + '/')
kalviumSDK.setInterventionAP(
    import.meta.env.VITE_INTERVENTION_API_ENDPOINT + '/'
)

kalviumSDK.setMarkerAP(import.meta.env.VITE_MARKER_API_ENDPOINT + '/')
kalviumSDK.setSchedulerAP(import.meta.env.VITE_SCHEDULER_API_ENDPOINT)
kalviumSDK.setBoaAp(import.meta.env.VITE_BOA_ENDPOINT)

const App = () => {
    return (
        <Suspense fallback={<PageLoader />}>
            <AuthContext.Provider
                value={{
                    kalviumKc: kalviumSDK.keycloak,
                }}
            >
                {kalviumSDK.keycloak.isLoggedIn() && <UnitFeedback />}
                <IssueReporterProvider>
                    <ProctoringProvider>
                        <FullScreenProvider>
                            <DojoProvider>
                                <SideDrawerProvider>
                                    {/* /quiz/:ax_slug */}
                                    {kalviumSDK.keycloak.isLoggedIn() && (
                                        <IssueReporter />
                                    )}
                                    <Router />
                                </SideDrawerProvider>
                            </DojoProvider>
                        </FullScreenProvider>
                    </ProctoringProvider>
                </IssueReporterProvider>
            </AuthContext.Provider>
        </Suspense>
    )
}

const root = ReactDOM.createRoot(document.getElementById('root'))

const renderApp = () => {
    return root.render(
        <ThemeProvider>
            <ChakraProvider theme={chakraTheme}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </ChakraProvider>
        </ThemeProvider>
    )
}

// Initialize Keycloak and then render the application
kalviumSDK.keycloak.initKeycloak(renderApp)
